import autosize from 'autosize';

/**
 * Use autosize library for textareas.
 */
export default () => {

  function applyAutosize() {
    autosize($('textarea'));
  }

  applyAutosize();

  // Listen for AJAX loading
  $(document).on('aauw-dynamic-form-inserted', applyAutosize);
};
